export default __webpack_public_path__ + "static/media/home_thumb_9D.a7725e37.png";